import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";

export const customerProductSummaryGetApi = async (payload) => {
  const params = new URLSearchParams();
  
  params.append("customerId", payload?.customerId);

  if (payload?.vendorCode) {
    params.append("vendorCode", payload.vendorCode);
  }

  if (payload?.productIdentifier) {
    params.append("productIdentifier", payload.productIdentifier);
  }

  if (payload?.fromDate) {
    params.append("fromDate", payload.fromDate);
  }

  if (payload?.toDate) {
    params.append("toDate", payload.toDate);
  }

  if (payload?.includeArchive !== undefined) {
    params.append("includeArchive", payload.includeArchive);
  }

  // const url = `${API.customerProductBudgetSummary}?${params.toString()}`;

  // const { data = {} } = await axiosInstanceClient.get(url);

  const { data = {} } = await axiosInstanceClient.get(API.customerProductBudgetSummary, {
    params: {
      customerId: payload?.customerId,
      vendorCode: payload?.vendorCode,
      productIdentifier: payload?.productIdentifier,
      fromDate: payload?.fromDate,
      toDate: payload?.toDate,
      includeArchive: payload?.includeArchive,
    },
  });
  
  return data;
};
